module.exports = __webpack_public_path__ + "img/our-mission-shape1.e51bbbe0.png";